import { isValidPhoneNumber } from 'libphonenumber-js/mobile';
import { Component, Prop, Vue } from 'vue-property-decorator';
import VueSelect from 'vue-select';
import { formatPhoneNumber, getAllCountryOptions, getDefaultCountry, parsePhoneNumber, } from './helpers';
@Component({
    name: 'PhoneNumberInput',
    components: { VueSelect },
    inheritAttrs: false,
})
export default class default_1 extends Vue {
    @Prop({ default: '' })
    value;
    @Prop({ default: null })
    autocomplete;
    countryOptions = getAllCountryOptions();
    defaultCountry = getDefaultCountry(this.value);
    selectedCountry = this.defaultCountry;
    dropdownOpen = false;
    formattedPhoneNumberValue = formatPhoneNumber(this.value, this.defaultCountry);
    get input() {
        return this.value;
    }
    set input(value) {
        this.$emit('input', value);
    }
    searchFilterCallback(option, _, search) {
        // Is searchable by all properties (country code, calling code and country name)
        for (const property in option) {
            if (option[property].toLowerCase().includes(search.toLowerCase())) {
                return true;
            }
        }
        return false;
    }
    // TODO: fix open dropdown reopening on chevron click
    // Not an issue when using @vueform/multiselect
    handleSearchFocus() {
        this.dropdownOpen = true;
    }
    clearValidationError() {
        ;
        this.$refs.phoneNumberInputElement?.setCustomValidity('');
    }
    validatePhoneNumber() {
        if (this.input && !isValidPhoneNumber(this.input)) {
            ;
            this.$refs.phoneNumberInputElement?.setCustomValidity('Please enter a valid mobile phone number.');
        }
    }
    handleBlur() {
        this.$nextTick(() => {
            const isFocusStillWithinComponent = this.dropdownOpen || document.activeElement === this.$refs.phoneNumberInputElement;
            if (isFocusStillWithinComponent) {
                this.clearValidationError();
            }
            else {
                this.validatePhoneNumber();
            }
            this.$emit('blur');
        });
    }
    handleSearchBlur() {
        this.dropdownOpen = false;
        this.handleBlur();
    }
    focusPhoneNumberInput() {
        ;
        this.$refs.phoneNumberInputElement?.focus();
    }
    updatePhoneNumberValue(updatedNumber) {
        this.clearValidationError();
        const { parsedNumber, updatedCountry } = parsePhoneNumber(updatedNumber, this.selectedCountry, this.defaultCountry);
        this.selectedCountry = updatedCountry;
        this.input = parsedNumber;
        this.formattedPhoneNumberValue = formatPhoneNumber(updatedNumber, this.selectedCountry);
    }
    handleCountrySelect() {
        // Reusing formatted value since the number isn't changing
        // libphonenumber-js doesn't have trouble parsing it
        this.updatePhoneNumberValue(this.formattedPhoneNumberValue);
        this.dropdownOpen = false;
        this.focusPhoneNumberInput();
    }
    // Allow reselection of same country (close dropdown and do nothing)
    // VueSelect doesn't have an obvious way to allow selection of currently selected item
    handleCountryReselect(reselectedCountry) {
        this.selectedCountry = reselectedCountry;
        this.dropdownOpen = false;
        this.focusPhoneNumberInput();
    }
    handlePhoneNumberInputChange(event) {
        const updatedNumber = event.target.value;
        this.updatePhoneNumberValue(updatedNumber);
    }
}
